<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h6 class="label-black">MOVIMIENTOS INTERNOS DE DOCUMENTOS</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area" style="margin-top: 0px">
                        <div class="form-group" >
                          <label class="label-black">Tipo de Movimiento</label>
                          <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event)">
                            <option value= 0>SELECCIONE UN TIPO DE MOVIMIENTO</option>
                            <option v-for="opcion in Tipos" :key="opcion.TipoId" :value="opcion.TipoId" >{{opcion.Nombre}}</option>
                          </select>
                        </div>
                        <div class="form-group align-self-center" v-if="parametros_Tipo.tipoId==1">
                          <button class="btn btn-sm btn-info" @click='ObtenerResguardados()'>Obtener Recientes</button>
                        </div>
                        <div class="form-group align-self-center" id="Codigo_div" v-if="parametros_Tipo.tipoId==1">
                            <label class="label-black">Código:</label>
                            <input type="text" class="form-control" v-model="CodigoBarras" placeholder="##############" v-on:keyup.enter= 'DetectarEnter'/>
                        </div>
                        <div id="BotonBusqueda_div" class="form-group text-right" style="margin-top: 27px;" v-if="parametros_Tipo.tipoId==1">
                            <button class="btn btn-sm btn-custom" @click='ConsultarDocumento()'>Buscar Documento</button>
                        </div>
                    
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="parametros_Tipo.tipoId==1">
                <div class="area custom-area" style="margin-top: 0px">
                    <div class="row">
                        <div class="form-group col-12">
                          <h6 class="label-black">Listado de Documentos para Envío, Total de Documentos : {{ListaEnvios.length}}</h6>
                        </div>
                    </div>
                    <div class="row table-responsive" id ="tablaEnvios">
                            <table class="table table-striped table-light table-hover table-sm" >
                                <thead class="thead-custom">
                                    <tr>
                                        <!-- <th><input id="checkTotodos" type="checkbox" v-on:click="SelectEnvioAll($event)" v-model="SeleccionarResguardos" class="vertical-align-bottom"/></th> -->
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Tipo de Elemento</th>
                                        <th>Usuario Actual</th>
                                        <th>Fecha de Recepción</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark" v-for="Lista in ListaEnvios" :key ="Lista.InventarioDocumentoId">
                                    <tr >
                                        <!-- <td witdh ="100" v-bind:rowspan="Lista.Movimientos.length + 1">
                                          <input v-model="aResguardoEnviar" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" checked="true"/>
                                        </td> -->
                                        <td width ="200" v-bind:rowspan="Lista.Movimientos.length + 1"><h6 class="label-black"><span class="badge badge-primary">{{Lista.TipoDocumento.Nombre}}</span></h6></td>
                                        <td width ="100" v-bind:rowspan="Lista.Movimientos.length + 1">{{Lista.Consecutivo}}/{{Lista.Anio}}</td>
                                    </tr>
                                    <tr v-for="Movimientos in Lista.Movimientos" :key ="Movimientos.MovimientoDocumentoId" >
                                      <td width ="300" v-html="desglosaContenido(Movimientos)"></td>
                                      <!-- <td width ="300" v-if="Movimientos.VolumenId!=null && Movimientos.TerceriaId== null && Movimientos.IncidenteId==null">Tomo No: {{Movimientos.Volumen.NumVolumen}}</td>
                                        <td width ="300" v-else-if="Movimientos.VolumenId==null && Movimientos.TerceriaId!= null && Movimientos.IncidenteId==null">Tercería No: {{Movimientos.Terceria.NumeroTerceria}}, Tipo {{Movimientos.Terceria.TipoTerceria}}</td>
                                        <td width ="300" v-else>Incidente No: {{Movimientos.Incidente.NumeroIncidente}}, Tipo: {{Movimientos.Incidente.TipoIncidente}}</td> -->
                                        <td width ="300" v-if="Movimientos.UsuarioQuienRecibe!=null">{{Movimientos.UsuarioQuienRecibe.Nombre}} {{Movimientos.UsuarioQuienRecibe.ApellidoPaterno!=null ? Movimientos.UsuarioQuienRecibe.ApellidoPaterno: ""}} {{Movimientos.UsuarioQuienRecibe.ApellidoMaterno!=null ? Movimientos.UsuarioQuienRecibe.ApellidoMaterno : ""}}</td>
                                        <td witdh="300" v-else></td>
                                        <td v-html="obtenFechaConFormato(Movimientos.FechaRecepcion)"></td>
                                        <td width="30" class="category_enabled text-center">
                                            <input type="checkbox" v-model="SelEnviar" v-bind:value="Movimientos"/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>
                    <div class="row">
                      <div id="BotonMover_div" class="text-right" v-if="SelEnviar.length>0">
                          <button class="btn btn-sm btn-custom" @click='Enviar()'>Enviar Documento(s)</button>
                      </div>
                    </div>
                    <div v-if="modalEnvio==true">
                      <ModalEnvio :adminEnvio= this.EnviosArchivista :ListadoParaEnvio= this.MovimientosModal :TotalVolumenes= 0 :usrArea= this.Usuario :JuicioDatos= this.Juicio @dialogo='EstatusModal($event)'></ModalEnvio>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="parametros_Tipo.tipoId==2">
                <div class="area custom-area" style="margin-top: 0px">
                    <div class="row">
                        <h6 class="label-black">Listado de Documentos para Recepción, Total de Documentos : {{ListaRecepcion.length}}</h6>
                    </div>
                    <div class="row table-responsive" id="tablaRecepcion">
                            <table class="table table-striped table-light table-hover table-sm">
                                <thead class="thead-custom">
                                    <tr>
                                        <th><input id="checkTotodos" type="checkbox" v-on:click="SelectAll($event)" v-model="SeleccionarTodos" class="vertical-align-bottom"/></th>
                                        <th>Tipo</th>
                                        <th>Consecutivo  
                                          <a v-on:click="sortElemento('CodigoBarras')" title="Cambiar Orden">
                                              <i class="fas fa-sort"></i>
                                          </a>
                                        </th>
                                        <th>Tipo de Elemento</th>
                                        <th>Usuario Emisor</th>
                                        <th>Fecha de Envío
                                          <a v-on:click="sortElemento('Movimientos.FechaMovimiento')" title="Cambiar Orden">
                                              <i class="fas fa-sort"></i>
                                          </a>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark" v-for="Lista in ListaRecepcionSorted" :key ="Lista.InventarioDocumentoId">
                                    <tr >
                                      <td witdh ="100" v-bind:rowspan="Lista.Movimientos.length + 1">
                                        <input v-model="aEnviar" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" checked="true"/>
                                      </td>
                                      <td width ="170" v-bind:rowspan="Lista.Movimientos.length + 1"><span class="badge badge-primary">{{Lista.TipoDocumento.Nombre}}</span></h6></td>
                                      <td class="text-center" width ="150" v-bind:rowspan="Lista.Movimientos.length + 1">{{Lista.Consecutivo}}/{{Lista.Anio}}</td>
                                    </tr>
                                    <tr v-for="Movimientos in Lista.Movimientos" :key ="Movimientos.MovimientoDocumentoId" >
                                      <td width ="300" v-html="desglosaContenido(Movimientos)"></td>
                                      <!-- <td width ="300" v-if="Movimientos.VolumenId!=null && Movimientos.TerceriaId== null && Movimientos.IncidenteId==null">Tomo No: {{Movimientos.Volumen.NumVolumen}}</td>
                                      <td width ="300" v-else-if="Movimientos.VolumenId==null && Movimientos.TerceriaId!= null && Movimientos.IncidenteId==null">Tercería No: {{Movimientos.Terceria.NumeroTerceria}}, Tipo {{Movimientos.Terceria.TipoTerceria}}</td>
                                      <td width ="300" v-else>Incidente No: {{Movimientos.Incidente.NumeroIncidente}}, Tipo: {{Movimientos.Incidente.TipoIncidente}}</td> -->
                                      <td width ="250" v-if="Movimientos.UsuarioQuienPresta!=null">{{Movimientos.UsuarioQuienPresta.Nombre}} {{Movimientos.UsuarioQuienPresta.ApellidoPaterno!=null ? Movimientos.UsuarioQuienPresta.ApellidoPaterno: ""}} {{Movimientos.UsuarioQuienPresta.ApellidoMaterno!=null ? Movimientos.UsuarioQuienPresta.ApellidoMaterno : ""}}</td>
                                      <td witdh="250" v-else-if="Movimientos.UsuarioQuienPresta==null && Movimientos.AreaExterna!=null">Área Externa: {{Movimientos.AreaExterna.Nombre}}</td>
                                      <td witdh="250" v-else></td>
                                      <td class="text-center" v-html="obtenFechaConFormato(Movimientos.FechaMovimiento)"></td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>
                    <div id="BotonMover_div" class="row" v-if="ListaRecepcion.length>0">
                      <div class="form-group col-6 text-left">
                        <button class="btn btn-sm btn-secondary " @click='Imprimir(ListaRecepcion)'>&nbsp;&nbsp;&nbsp; Imprimir Listado &nbsp;&nbsp;&nbsp;</button>
                      </div>
                      <div class="form-group col-6 text-right">
                        <button class="btn btn-sm btn-custom" @click='Recibir()'>Recepción Documento(s)</button>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import ModalParaEnvio from '@/components/ArchivoJudicial/Comun/DatosEnvio.vue'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'

export default {
    components: {
        ModalEnvio: ModalParaEnvio
    },
    data(){
        return{
            Listado: [],
            CodigoBarras: "",
            ListaEnvios: [],
            ListaRecepcion: [],
            MovimientosModal:[],
            AreaQueConsulta: {},
            ubicacionActual:"",
            Tipos: [
                {TipoId: 1, Nombre: "ENVÍO"},
                {TipoId: 2, Nombre: "RECEPCIÓN"}
            ],
            parametros_Tipo: {
                tipoId: 0
            },
            modalEnvio: false,
            EnviosArchivista: false,
            Usuario : {},
            Juicio : {},
            aEnviar:[],
            aResguardoEnviar:[],
            SeleccionarTodos: false,
            SeleccionarResguardos: false,
            currentSort:'CodigoBarras',
            currentSortDir:'asc',
            SelEnviar: []
        }
    },
    methods: {
        cambiarTipo(datos){
            this.parametros_Tipo.tipoId = parseInt(datos.target.value);
            $('#navtablaEnvios').remove();
            $('#navtablaRecepcion').remove();
            if(this.parametros_Tipo.tipoId==1)
            {
              
              this.$nextTick(()=> { PaginarTabla('tablaEnvios', 20)})

            }
            if(this.parametros_Tipo.tipoId==2)
            {
              this.$nextTick(()=> { PaginarTabla('tablaRecepcion', 20)})
              this.ObtenerListaRecepcion();
            }
            this.CodigoBarras = "";
            this.SeleccionarTodos= false;
        },
        obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        ConsultarDocumento(){
            var tipo = this.parametros_Tipo.tipoId;
            var Resultado = this.ChecaCodigo(this.CodigoBarras);
              if( Resultado.Estatus== true)
              {
                if(this.VerificaEnListado(this.CodigoBarras) == true)
                {
                  comun.mensajeDeAlerta("El documento ya existe en el listado.", null, null);
                }
                else
                {
                  var peticion = {
                  "AreaId": -1,
                  "TipoDocumentoId" : -1,
                  "Anio" : null,
                  "Consecutivo": null,
                  "CodigoBarras": this.CodigoBarras.trim(),
                  "Archivo": true
                      };
                  axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
                  comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                  .then( respuesta => {
                      if(respuesta.data.SiHayError)
                      {
                          console.log(respuesta);
                          comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                      }
                      else
                      {   
                          var DocumentoObtenido = respuesta.data.GetDocumento;
                          this.Usuario = respuesta.data.Usuario;
                          this.Juicio= DocumentoObtenido.Juicio;
                          if(DocumentoObtenido!=null && DocumentoObtenido.InventarioDocumentoId>0)
                          {
                            if(this.checaUbicacionElementos(DocumentoObtenido, this.AreaQueConsulta.Area.AreaId)==true)
                                  {
                                      switch(tipo)
                                      {
                                          case 1:
                                              this.ObtenerListaParaEnvio(DocumentoObtenido);
                                              break;
                                          case 2:
                                              this.ObtenerListaRecepcion(DocumentoObtenido);
                                              break;
                                          default:
                                              comun.mensajeDeAlerta("Seleccione un tipo de movimiento", null, null);
                                              break
                                      };
                            }
                            else
                            {
                              comun.mensajeDeAlerta("No es posible Consultar un documento con ubicación y/o asignacion distinta en esta Área, ubicación actual :  " + this.ubicacionActual, null, null);
                            }
                          }                 
                      }
                  })
                  .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  });
                }
              }
              else
              {
                  comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
              }

        },
        ObtenerListaParaEnvio(documento){
            var peticion={
                "CodigoBarras": documento.CodigoBarras
            };
        
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.GenerarListaInterna, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                    var DocumentosEnvio = respuesta.data;
                    
                    comun.SeEstaCargandoInformacion(false);
                    if(DocumentosEnvio.GetListaDocumentos.length>0 || DocumentosEnvio.GetListaIncidentes.length>0 || DocumentosEnvio.GetListaTercerias.length>0)
                    {
                      this.formatoTablaEnvio(documento, DocumentosEnvio);
                    }
                    else
                    {
                      var mensajeExtendido ="";
                      if(documento.Volumenes!=null && documento.Volumenes.length>0)
                      {
                        $.each(documento.Volumenes, function(a, volumen){
                          if(volumen.MovimientoVolumen!=null)
                          {
                            if(volumen.MovimientoVolumen.FechaRecepcion==null)
                            {
                              var nombreAreaREcibe = volumen.MovimientoVolumen.AreaQueRecibe != null ? volumen.MovimientoVolumen.AreaQueRecibe.Nombre : "";
                              mensajeExtendido = mensajeExtendido + "Volumen No. " + volumen.NumVolumen + " pendiente de recepción por: " + (volumen.MovimientoVolumen.UsuarioQuienRecibe!=null ? (volumen.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " +volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno) : 
                                                                                                                                            nombreAreaREcibe) + "</br>";
                            }
                          }
                        });
                      }
                      if(documento.Tercerias!=null && documento.Tercerias.length>0)
                      {
                        $.each(documento.Tercerias, function(a, terceria){
                          if(terceria.MovimientoTerceria!=null)
                          {
                            if(terceria.MovimientoTerceria.FechaRecepcion==null)
                            {
                              mensajeExtendido = mensajeExtendido + "Tercería No. " + terceria.NumeroTerceria + " pendiente de recepción por: " + terceria.MovimientoTerceria.UsuarioQuienRecibe!=null ? (terceria.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno) : 
                                                                                                                                                  (terceria.MovimientoTerceria.AreaQueRecibe!=null ? terceria.MovimientoTerceria.AreaQueRecibe.Nombre : "" ) + "</br>";
                            }
                          }
                        });
                      }
                      if(documento.Incidentes!=null && documento.Incidentes.length>0)
                      {
                        $.each(documento.Incidentes, function(a, incidente){
                          if(incidente.MovimientoIncidente!=null)
                          {
                            if(incidente.MovimientoIncidente.FechaRecepcion==null)
                            {
                              mensajeExtendido = mensajeExtendido + "Incidente No. " + incidente.NumeroIncidente + " pendiente de recepción por: " + incidente.MovimientoIncidente.UsuarioQuienRecibe!=null ? (incidente.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno) : 
                                                                                                                                                      (incidente.MovimientoIncidente.AreaQueRecibe!=null ? incidente.MovimientoIncidente.AreaQueRecibe.Nombre : "") + "</br>";
                            }
                          }
                        });
                      }
                      comun.mensajeDeAlerta("El Documento consultado no puede ser enviado por el usuario en sesión. Esta Asignado a otro usuario : </br>" + mensajeExtendido , null, null);
                    }
                    
                    this.CodigoBarras= null;
                }
                })
            .catch(excepcion => {
              comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                
                })
        },
        DetectarEnter: function(e){
            var Resultado = {}
            if (e.keyCode==13)
            {
                if(this.CodigoBarras != null || this.CodigoBarras != "")
                {
                  Resultado = this.ChecaCodigo(this.CodigoBarras);
                  if(Resultado.Estatus==true)
                  {
                    this.ConsultarDocumento();
                  }
                  else
                  {
                    comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
                  }
                }
                // else
                // {
                //     comun.mensajeDeAlerta("Escriba/Escan Código de Barras", null, null);
                // }
            }
        },
        ChecaCodigo: function(codigo){
          var Verificado= {
              Estatus: false,
              Mensaje: ""
          }
          if(this.AreaQueConsulta.Area.AreaId!=95)
          {
            switch(codigo.length)
            {
              case 13:
                var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                if (estado==false)
                {
                  Verificado.Estatus = estado;
                  Verificado.Mensaje = "Verificar código de barras, debe ser numerico"
                }
                else
                {
                  Verificado.Estatus = estado;
                  Verificado.Mensaje = ""
                }
                break;
              default:
                  Verificado.Estatus = false;
                  if(codigo.length<13)
                  {
                    Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos"
                  };
                  if(codigo.length>13)
                  {
                    Verificado.Mensaje = "Verificar código de barras, sobrepasa los 13 digitos numericos"
                  }
                
                break;  
            }
          }
          else
          {
            switch(codigo.length)
            {
              case 13:
                var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                var anio = parseInt(codigo.substr(5,4));
                console.log(anio);
                if(anio<=2020)
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Verificar código de barras, para documento del 2020 o inferiores se requiere complementar con numero romano correspondiente al área a consultar"
                                        + "</br>I   .- Juzgado Primero de Ejecución."
                                        + "</br>II  .- Juzgado Segundo de Ejecución."
                                        + "</br>III .- Unidad de Gestión";
                }
                else
                {
                  if (estado==false)
                  {
                    Verificado.Estatus = estado;
                    Verificado.Mensaje = "Verificar código de barras, debe ser numerico"
                  }
                  else
                  {
                    Verificado.Estatus = estado;
                    Verificado.Mensaje = ""
                  }
                }
                break;
              case 14:
                var anio = parseInt(codigo.substr(5,4));
                var numerico14 = codigo.substr(0,13);
                var romano14 = codigo.substr(13,1);
                if(anio<=2020)
                {
                  var estadoNumerico14 = !isNaN(parseFloat(numerico14)) && isFinite(numerico14);
                  var estadoRomano14 = romano14!="I" ? false: true;
                  if(estadoNumerico14==true && estadoRomano14 ==true)
                  {
                    Verificado.Estatus = estadoNumerico14;
                    Verificado.Mensaje = ""
                  }
                  else
                  {
                    if(estadoNumerico14==false && estadoRomano14 ==true)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numero"
                    }
                    if(estadoNumerico14==true && estadoRomano14 ==false)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                    }
                  }
                }
                else
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                }
                break;
              case 15:
                var anio = parseInt(codigo.substr(5,4));
                var numerico15 = codigo.substr(0,13);
                var romano15 = codigo.substr(13,2);
                if(anio<=2020)
                {
                  var estadoNumerico15 = !isNaN(parseFloat(numerico15)) && isFinite(numerico15);
                  var estadoRomano15 = romano15!="II" ? false: true;
                  if(estadoNumerico15==true && estadoRomano15 ==true)
                  {
                    Verificado.Estatus = estadoNumerico15;
                    Verificado.Mensaje = ""
                  }
                  else
                  {
                    if(estadoNumerico15==false && estadoRomano15 ==true)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numero"
                    }
                    if(estadoNumerico15==true && estadoRomano15 ==false)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                    }
                  }
                }
                else
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                }
                break;
              case 16:
                var anio = parseInt(codigo.substr(5,4));
                var numerico16 = codigo.substr(0,13);
                var romano16 = codigo.substr(13,3);
                if(anio<=2020)
                {
                  var estadoNumerico16 = !isNaN(parseFloat(numerico16)) && isFinite(numerico16);
                  var estadoRomano16 = romano16!="III" ? false: true;
                  if(estadoNumerico16==true && estadoRomano16 ==true)
                  {
                    Verificado.Estatus = estadoNumerico16;
                    Verificado.Mensaje = ""
                  }
                  else
                  {
                    if(estadoNumerico16==false && estadoRomano16 ==true)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numericos"
                    }
                    if(estadoNumerico16==true && estadoRomano16 ==false)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                    }
                  }
                }
                else
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                }
                break;
              default:
                  Verificado.Estatus = false;
                  if(codigo.length<13)
                  {
                    Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos y en su caso numero romano"
                  };
                  if(codigo.length>16)
                  {
                    Verificado.Mensaje = "Verificar código de barras, sobrepasa los 16 digitos"
                  }
                
                break;  
            }
          }
          return Verificado;
        },
        checaUbicacionElementos(documentos, areaActual){
          var contador = 0;
          var Uactual = "";
          
          $.each(documentos.Volumenes, function(index, listado)
          {
            Uactual =listado.Area.Nombre;
            if(listado.Area.AreaId == areaActual)
            {
              contador += 1;
            }
            else
            {
              if(listado.MovimientoVolumen!=null)
                {
                if(listado.MovimientoVolumen.AreaQueRecibe.AreaId == areaActual)
                  {
                    contador += 1;
                    
                  }
                }
            }
          });

          $.each(documentos.Incidentes, function(index, listado)
          {
            Uactual =listado.Area.Nombre;
            if(listado.Area.AreaId == areaActual)
            {
              contador += 1;
            }
            else
            {
              if(listado.MovimientoIncidente!=null)
                {
                if(listado.MovimientoIncidente.AreaQueRecibe.AreaId == areaActual)
                  {
                    contador += 1;
                    
                  }
                }
            }
          });
          $.each(documentos.Tercerias, function(index, listado)
          {
            Uactual =listado.Area.Nombre;
            if(listado.Area.AreaId == areaActual)
            {
              contador += 1;
            }
            else
            {
              if(listado.MovimientoIncidente!=null)
                {
                if(listado.MovimientoIncidente.AreaQueRecibe.AreaId == areaActual)
                  {
                    contador += 1;
                    
                  }
                }
            }
          });

          this.ubicacionActual = Uactual;
          
          if(contador > 0)
          {
            return true;
          }
          else
          {
            return false;
          }
        },
        formatoTablaEnvio(documento, datos){
            let _this = this;
            var listaPrevia = []
            $('#navtablaEnvios').remove();
            $('#navtablaRecepcion').remove();
            if(datos.GetListaDocumentos.length>0)
            {
                $.each(datos.GetListaDocumentos, function(index, listado)
                {
                    listaPrevia.push(listado);
                })
            };
          if(listaPrevia.length>0)
          {
            var temporal = this.AgruparInventarioDocumentoId(documento, listaPrevia);
            this.ListaEnvios.push(temporal[0]);
            this.ListaEnvios.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
            this.$nextTick(()=> { PaginarTabla('tablaEnvios', 20)})
            $.each(temporal[0].Movimientos, function(id, movimiento){
            _this.SelEnviar.push(movimiento)
          })
          }
        },
        formatoTablaRecepcion(datos){//documento, datos){
          $('#navtablaEnvios').remove();
          $('#navtablaRecepcion').remove();
          if(datos.length!=null && datos.length>0)
          {
            this.ListaRecepcion = this.AgruparInventarioDocumentoId(null, datos)//);//documento, listaPrevia));
            this.ListaRecepcion.sort((a,b)=>(a.CodigoBarras<b.CodigoBarras ? -1:1));
            this.SelectAll();
            this.SeleccionarTodos = true;
            this.$nextTick(()=> { PaginarTabla('tablaRecepcion', 20)})
          }
        },
        EliminarDocumentoEnvio(lista, datos){
          var IndiceDocumento = this.ListaEnvios.indexOf(lista);
          var IndiceElemento = this.ListaEnvios[IndiceDocumento].Movimientos.indexOf(datos);
           bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Desea Eliminar el Elemento de la Lista para Envío?",
            buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
              }
            },
            callback: (respuestaSalir) => {
              if (respuestaSalir) {
                this.ListaEnvios[IndiceDocumento].Movimientos.splice(IndiceElemento,1);
                if(this.ListaEnvios[IndiceDocumento].Movimientos.length==0)
                {
                  this.ListaEnvios.splice(IndiceDocumento,1);
                }
              }
              }
            });
        },
        EliminarDocumentoRecepcion(lista, datos){
          var IndiceDocumento = this.ListaRecepcion.indexOf(lista);
          var IndiceElemento = this.ListaRecepcion[IndiceDocumento].Movimientos.indexOf(datos);
           bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Desea Eliminar el Elemento de la Lista para Envío?",
            buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
              }
            },
            callback: (respuestaSalir) => {
              if (respuestaSalir) {
                this.ListaRecepcion[IndiceDocumento].Movimientos.splice(IndiceElemento,1);
                if(this.ListaRecepcion[IndiceDocumento].Movimientos.length==0)
                {
                  this.ListaRecepcion.splice(IndiceDocumento,1);
                }
              }
              }
            });
        },
        AgruparInventarioDocumentoId(documento, datos){//documento, datos){
            var ListaInicial=[];
            $.each(datos, function(index, datosEnvio)
            {
              var documentoEnMovimiento = {};
              if(documento==null)
              {
                if(datosEnvio.VolumenId!=null)
                {
                  documentoEnMovimiento= datosEnvio.Volumen.Inventario;
                };
                if(datosEnvio.IncidenteId!=null)
                {
                  documentoEnMovimiento = datosEnvio.Incidente.Inventario
                };
                if(datosEnvio.TerceriaId!=null)
                {
                  documentoEnMovimiento = datosEnvio.Terceria.Inventario
                }
              }
              else
              {
                documentoEnMovimiento = documento;
              };
              // var volumenesTemporal = {
              //   "Area" : documentoEnMovimiento.Volumenes[0].Area,
              //   "Amparos" : documentoEnMovimiento.Volumenes[0].Amparos,
              //   "InventarioDocumentoId" : documentoEnMovimiento.Volumenes[0].InventarioDocumentoId,
              //   "VolumenId" : documentoEnMovimiento.Volumenes[0].VolumenId,
              //   "NumVolumen" : documentoEnMovimiento.Volumenes[0].NumVolumen,
              //   "Contenedor" : documentoEnMovimiento.Volumenes[0].Contenedor,
              //   "EstatusVolumenes" : documentoEnMovimiento.Volumenes[0].EstatusVolumenes,
              // };
              var chequeo = ListaInicial.find(e=>e.InventarioDocumentoId == documentoEnMovimiento.InventarioDocumentoId);
              if(chequeo == undefined || chequeo == false)
              {

                ListaInicial.push({"InventarioDocumentoId": documentoEnMovimiento.InventarioDocumentoId,
                  "TipoDocumento": documentoEnMovimiento.TipoDocumento,
                  "Anio": documentoEnMovimiento.Anio,
                  "CodigoBarras": documentoEnMovimiento.CodigoBarras,
                  "Consecutivo": documentoEnMovimiento.Consecutivo,
                  "Partes": documentoEnMovimiento.Partes,
                  "Juicio": documentoEnMovimiento.Juicio,
                  "SedeArchivo": documentoEnMovimiento.SedeArchivo,
                  "Volumenes": documentoEnMovimiento.Volumenes,
                  "Movimientos": [
                  {
                    "MovimientoDocumentoId": datosEnvio.MovimientoDocumentoId,
                    "FechaMovimiento": datosEnvio.FechaMovimiento,
                    "UsuarioQuienPresta": datosEnvio.UsuarioQuienPresta,
                    "UsuarioQuienRecibe": datosEnvio.UsuarioQuienRecibe,
                    "AreaQuePresta": datosEnvio.AreaQuePresta,
                    "AreaQueRecibe": datosEnvio.AreaQueRecibe,
                    "AreaExterna": datosEnvio.AreaExterna,
                    "IncidenteId": datosEnvio.IncidenteId,
                    "Incidente": datosEnvio.Incidente!= null? datosEnvio.Incidente : null,
                    "VolumenId": datosEnvio.VolumenId,
                    "Volumen": datosEnvio.Volumen!=null ? datosEnvio.Volumen : null,
                    "TerceriaId": datosEnvio.TerceriaId,
                    "Terceria": datosEnvio.Terceria!=null ? datosEnvio.Terceria : null,
                    "TiposMovimientos": datosEnvio.TiposMovimientos,
                    "FechaRecepcion": datosEnvio.FechaRecepcion
                  }],
                });
              }
              else{
                chequeo.Movimientos.push({
                  "MovimientoDocumentoId": datosEnvio.MovimientoDocumentoId,
                  "FechaMovimiento": datosEnvio.FechaMovimiento,
                  "UsuarioQuienPresta": datosEnvio.UsuarioQuienPresta,
                  "UsuarioQuienRecibe": datosEnvio.UsuarioQuienRecibe,
                  "AreaQuePresta": datosEnvio.AreaQuePresta,
                  "AreaQueRecibe": datosEnvio.AreaQueRecibe,
                  "AreaExterna": datosEnvio.AreaExterna,
                  "IncidenteId": datosEnvio.IncidenteId,
                  "Incidente": datosEnvio.Incidente!= null? datosEnvio.Incidente : null,
                  "VolumenId": datosEnvio.VolumenId,
                  "Volumen": datosEnvio.Volumen!=null ? datosEnvio.Volumen : null,
                  "TerceriaId": datosEnvio.TerceriaId,
                  "Terceria": datosEnvio.Terceria!=null ? datosEnvio.Terceria : null,
                  "TiposMovimientos": datosEnvio.TiposMovimientos,
                  "FechaRecepcion": datosEnvio.FechaRecepcion});
                    }
            });
          return ListaInicial;
        },
        Enviar() {
          this.MovimientosModal = this.ObtenerSeleccionadosEnvio();
          if (this.MovimientosModal.length>0)
              {
                this.modalEnvio = true;
              }
              else
              {
                this.modalEnvio = false;
                comun.mensajeDeAlerta("No hay elementos para envío.", null, null);
              }
        },
        EstatusModal(valor){
          let _this=this;
            this.modalEnvio = valor.Cerrado;
            if(valor.Enviado==true)
            {
              $('#navtablaEnvios').remove();
              this.SelEnviar = [];
              this.MovimientosModal = [];
              this.ListaEnvios = [];
              this.ObtenerResguardados();
              
              // $.each(this.aResguardoEnviar, function(id, documento){
              //   let elementos = _this.ListaEnvios.filter(e=>e.InventarioDocumentoId==documento);
              //   let Index = _this.ListaEnvios.indexOf(elementos[0]);
              //   _this.ListaEnvios.splice(Index,1);
              //   _this.$nextTick(()=> { PaginarTabla('tablaEnvios', 20)})
              // });
              this.aResguardoEnviar= [];
              this.ListaRecepcion = [];
              comun.mensajeDeAlerta("Se han enviado los documentos en listado.", null, null);
            }
            
        },
        ObtenerListaRecepcion(bool){//documento){
            var peticion={
                "EsPrueba": false
                //"CodigoBarras": documento.CodigoBarras
            }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.InternoRecepcion, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                  var arrayTemporal = respuesta.data.GetListaParaRecepcion;
                  var DocumentosRecepcion = arrayTemporal; //.filter(a=>(a.VolumenId!=null && a.Volumen.Inventario.AmparoDocumentoPrincipal==null) || a.IncidenteId!=null || a.TerceriaId!=null);
                  comun.SeEstaCargandoInformacion(false);
                  this.formatoTablaRecepcion(DocumentosRecepcion);
                  this.CodigoBarras= null;
                }
            })
            .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
            })
        },
        Recibir() {
          var User = this.Usuario;
            var Movimientos= [];
            var seleccionados = this.SeleccionDocumentos();
            if(seleccionados.length>0)
            {
              $.each(seleccionados, function (index, documento){
                $.each(documento.Movimientos, function(i, movIds)
                {
                  Movimientos.push({
                                "MovimientoDocumentoId" : movIds.MovimientoDocumentoId,
                                "VolumenId" : movIds.VolumenId,
                                "IncidenteId": movIds.IncidenteId,
                                "TerceriaId": movIds.TerceriaId,
                                "FechaMovimiento" : movIds.FechaMovimiento,
                                "TiposMovimientos" : {"TipoMovimientoId": movIds.TiposMovimientos.TipoMovimientoId},
                                "UsuarioQuienPresta" : movIds.UsuarioQuienPresta !=null ? movIds.UsuarioQuienPresta : null,
                                "AreaQuePresta" : movIds.AreaQuePresta != null ? movIds.AreaQuePresta: null,
                                "UsuarioQuienRecibe" : movIds.UsuarioQuienRecibe!= null? movIds.UsuarioQuienRecibe : null ,
                                "AreaQueRecibe" : movIds.AreaQueRecibe !=null? movIds.AreaQueRecibe :null,
                                "SolicitudDocumentoId" : movIds.SolicitudDocumentoId,
                                "FechaRegistro" : movIds.FechaRegistro,
                                "UsuarioQuienRegistra" : {"IdUsuario": User.IdUsuario},
                                "Observaciones" : movIds.Observaciones,
                                "FechaRecepcion" : movIds.FechaRecepcion});
                  
                });
              
              $.each(documento.Volumenes, function(id, vol){
                    
                    if(vol.Amparos!=null && vol.Amparos.length>0)
                    {
                      $.each(vol.Amparos, function (x, amparo)
                      {
                        Movimientos.push({
                                  "MovimientoDocumentoId" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.MovimientoDocumentoId,
                                  "VolumenId" :amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.VolumenId,
                                  "IncidenteId": null,
                                  "TerceriaId": null,
                                  "FechaMovimiento" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.FechaMovimiento,
                                  "TiposMovimientos" : {"TipoMovimientoId": amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.TiposMovimientos.TipoMovimientoId},
                                  "UsuarioQuienPresta" :amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienPresta !=null ? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienPresta : null,
                                  "AreaQuePresta" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQuePresta != null ? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQuePresta: null,
                                  "UsuarioQuienRecibe" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienRecibe!= null? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienRecibe : null ,
                                  "AreaQueRecibe" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQueRecibe !=null? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQueRecibe :null,
                                  "SolicitudDocumentoId" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.SolicitudDocumentoId,
                                  "FechaRegistro" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.FechaRegistro,
                                  "UsuarioQuienRegistra" : {"IdUsuario": User.IdUsuario},
                                  "Observaciones" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.Observaciones,
                                  "FechaRecepcion" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.FechaRecepcion
                                  })
                      })
                    }
              });
              });
              var peticion={
                Movimientos
              };
              
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.RecepcionDocumento, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                  if(respuesta.data.SiHayError)
                  {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  }
                  else
                  {   
                    comun.SeEstaCargandoInformacion(false);
                    
                    bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "Desea Imprimir formato de Recepción?",
                    buttons: {
                    cancel: {
                      label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                      },
                    confirm: {
                      label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                      }
                    },
                    callback: (respuestaSalir) => {
                      if (respuestaSalir) {
                        this.Imprimir(seleccionados);
                        }
                      }
                    });
                     $('#navtablaRecepcion').remove();
                    this.ListaEnvios = [];
                    this.aEnviar=[];
                    this.ListaRecepcion = [];
                    this.ObtenerListaRecepcion(true);
                  }
                })
                  .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                  })
          }
          else
          {
            comun.mensajeDeAlerta("No hay documentos seleccionados para su recepción en sistema", null, null);
          }              
        },
        VerificaEnListado(codigo){
            if(this.ListaEnvios.length>0 && this.parametros_Tipo.tipoId == 1)
            {
                var check = this.ListaEnvios.filter(e=>e.CodigoBarras == codigo).length;
                if(check>0){
                    this.CodigoBarras="";
                    return true;
                }
            };
            if(this.ListaRecepcion.length>0 && this.parametros_Tipo.tipoId==2)
            {
                var check = this.ListaRecepcion.filter(e=>e.CodigoBarras == codigo).length;
                if(check>0){
                    this.CodigoBarras="";
                    return true;
                }
            };
            return false;
        },
        SelectAll(evento){
            this.aEnviar= [];
            if(this.SeleccionarTodos == false)
            {
                for (let i in this.ListaRecepcion)
                {
                    this.aEnviar.push(this.ListaRecepcion[i].InventarioDocumentoId)
                }
            }
        },
        SeleccionDocumentos(){
            let documentosSeleccionados = [];
            this.aEnviar.forEach((element) =>{
                let agregaDocumento = this.ListaRecepcion.find(rec=>rec.InventarioDocumentoId == element);
                //agregaDocumento.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 2;
                documentosSeleccionados.push(agregaDocumento);
            });
            return documentosSeleccionados;
        },
        sortElemento(dato){
          if(dato === this.currentSort) {
              this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = dato;
        },
        Imprimir: function(datos){
            var Info= this.AreaQueConsulta;
            var Titulo ="";
            
            let _this = this;
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12" padding-div-low" style="display: block; page-break-before: always;">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-3 align-self-center">');
            printWin.document.write('           <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('           <div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('               <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('           <div class="form-group col-3"></div></div></div>');
            printWin.document.write('   <div class="area"><div class="row">');
            printWin.document.write('           <div class="form-group col-12 align-self-center" >');
            printWin.document.write('               <div class="text-center">');
            printWin.document.write('                   <h5 class="text-center">RECEPCION DE DOCUMENTOS</h5></div>');
            printWin.document.write('               </div></div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 align-self-center" >');
            printWin.document.write('               <div class="text-center">');
            printWin.document.write('               <h6 class="text-center">FORMATO DE RECEPCIÓN</h6>');
            printWin.document.write('           </div></div></div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 text-right">');
            printWin.document.write('               <label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('           </div></div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 ">');
            printWin.document.write('           <label>Area: '+ Info.Area.Nombre +'</label>');
            printWin.document.write('       </div></div></div>');
            // Inicio Datos del Listado
            //printWin.document.write('<div class="area">');
            printWin.document.write('   <div class="row">');
            printWin.document.write('       <div class="form-group col-12">');
            printWin.document.write('           <div class="table-responsive">');
            printWin.document.write('               <table class="table table-striped table-light table-hover table-sm table-bordered" style="page-break-before: auto;">');
            printWin.document.write('                   <thead class="thead-dark" style="display:table-header-group"><tr><th></th><th>Tipo Documento</th><th>Consecutivo</th><th>Contenido</th>');
            printWin.document.write('                       </tr></thead><tbody class="text-dark">');
            $.each(datos, function(index, Lista)
            {
                var CadenaTexto = _this.DesglosaParaImpresion(Lista);
                var row = index +1;
                printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                printWin.document.write('<td width ="100">'+ row +'</td>');
                printWin.document.write('<td width ="400">'+ Lista.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td width ="200">'+ Lista.Consecutivo + "/"+ Lista.Anio +'</td>');
                printWin.document.write('<td>'+ CadenaTexto +'</td>');
                printWin.document.write('</tr>');
            });
            printWin.document.write('</tbody></table></div></div></div>');//</div>');
            // Fin Datos del Listado
            // Inicio Cuadro de Firmas
            printWin.document.write('<div class="row" style="page-break-inside: avoid; page-break-after: auto">');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>ENTREGA</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>RECIBE</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');
            // Fin Cuadro de Firmas

            printWin.document.write('</div>');
            
            printWin.document.write('</body></html>');
            var css = '@page { size: 8.5in 14in; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }

            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        DesglosaParaImpresion: function (datos) {
            let Contenido ="";
            $.each(datos.Movimientos, function(i, movimiento)
              {
                if(movimiento.Volumen!=null)
                {   
                  Contenido = Contenido + "<b>TOMO NO. </b>" + movimiento.Volumen.NumVolumen + "<br/>" ;
                  if(movimiento.Volumen.Amparos!=null && movimiento.Volumen.Amparos.length>0)
                  {
                    $.each(movimiento.Volumen.Amparos, function (id, valor) {
                    Contenido=Contenido + 'Amparo : ' + valor.AmparosDelDocumento.Consecutivo + "/" + valor.AmparosDelDocumento.Anio + '<br>';
                    })
                  }
                };
                if(movimiento.Incidentes!=null)
                {
                  Contenido = Contenido + "<b>INCIDENTE NO. </b>" + movimiento.Incidente.NumeroIncidente + " <br/>";
                }
                if(movimiento.Tercerias!=null)
                {
                  Contenido = Contenido + "<b>TERCERIA NO.</b>"+ movimiento.Terceria.NumeroTerceria + "<br/>";
                }
              }
            )
            
            return Contenido;
        },
        ObtenerResguardados: function () {
          let _this = this;
          let peticion = {
            "AreaId": this.AreaQueConsulta.Area.AreaId
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumentosResguardo, peticion,
                  comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                  .then( respuesta => {
                      if(respuesta.data.SiHayError)
                      { 
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                      }
                      else
                      {   
                        comun.SeEstaCargandoInformacion(false);
                        this.Usuario = respuesta.data.getUsuario;
                        var arrayObtenida = respuesta.data.GetListaParaEnvio;
                        var ListadoObtenido = arrayObtenida; //.filter(z=>(z.VolumenId!=null && z.Volumen.Inventario.AmparoDocumentoPrincipal==null) || z.IncidenteId!=null || z.TerceriaId!=null)
                        if(ListadoObtenido.length>0)
                        {
                          this.ListaEnvios= this.AgruparInventarioDocumentoId(null, ListadoObtenido); //respuesta.data.GetListaParaEnvio);
                          this.ListaEnvios.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
                          this.$nextTick(()=> { PaginarTabla('tablaEnvios', 20)})
                          $.each(this.ListaEnvios, function(id, envio)
                          {
                            $.each(envio.Movimientos, function(x, movimiento)
                            {
                              _this.SelEnviar.push(movimiento);
                            })
                          })
                        }
                        else
                        {
                          comun.mensajeDeAlerta("No hoy documentos para envío en los ultimos 5 dias, agregue manualmente.", null, null);
                        }
                      }
                  })
                  .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  });
          
        },
        SelectEnvioAll(evento){
          this.aResguardoEnviar= [];
            if(this.SeleccionarResguardos == false)
            {
                for (let i in this.ListaEnvios)
                {
                    this.aResguardoEnviar.push(this.ListaEnvios[i].InventarioDocumentoId)
                }
            }
        },
        SeleccionDocumentoEnvio(){
          let documentosSeleccionados = [];
            this.aResguardoEnviar.forEach((element) =>{
                let agregaDocumento = this.ListaEnvios.find(rec=>rec.InventarioDocumentoId == element);
                //agregaDocumento.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 2;
                documentosSeleccionados.push(agregaDocumento);
            });
            return documentosSeleccionados;
        },
        desglosaContenido(datos){
          let Contenido='';
          if(datos.VolumenId!=null)
          {
            Contenido=Contenido + 'Tomo No: ' + datos.Volumen.NumVolumen + '<br>';
            // if(datos.Volumen.Amparos!=null && datos.Volumen.Amparos.length>0)
            //   {
            //     $.each(datos.Volumen.Amparos, function (id, valor) {
            //       Contenido=Contenido + 'Amparo : ' + valor.AmparosDelDocumento.Consecutivo + "/" + valor.AmparosDelDocumento.Anio + '<br>';
            //     })
            //   }
          }
          if(datos.IncidenteId!=null)
          {
            Contenido=Contenido + 'Incidente No: ' + datos.Incidente.NumeroIncidente + '<br>';
          };
          if(datos.TerceriaId!=null)
          {
            Contenido=Contenido + 'Terceria No: ' + datos.Terceria.NumeroTerceria + '<br>';
          }
          return Contenido;
        },
        ObtenerSeleccionadosEnvio(){
            let documentosSeleccionados = [];
            let Listado = this.ListaEnvios;
            $.each(this.SelEnviar, function(id, movimiento)
            {
              var inventario = movimiento.VolumenId!=null ? (movimiento.Volumen.InventarioDocumentoId) : (movimiento.Terceria!=null ? movimiento.Terceria.InventarioDocumentoId : movimiento.Incidente.InventarioDocumentoId)
              var elemento =Listado.find(e=>e.InventarioDocumentoId == inventario);
              var chequeo = documentosSeleccionados.find(e=>e.InventarioDocumentoId == inventario);
              if(chequeo == undefined || chequeo == false)
              {
                documentosSeleccionados.push({"InventarioDocumentoId": elemento.InventarioDocumentoId,
                                    "TipoDocumento": elemento.TipoDocumento,
                                    "Anio": elemento.Anio,
                                    "CodigoBarras": elemento.CodigoBarras,
                                    "Consecutivo": elemento.Consecutivo,
                                    "Partes": elemento.Partes,
                                    "Juicio": elemento.Juicio,
                                    "SedeArchivo": elemento.SedeArchivo,
                                    "FechaRegistroArchivo":elemento.FechaRegistroArchivo,
                                    "Volumenes": elemento.Volumenes,
                                    "Movimientos": [
                                        {
                                        "MovimientoDocumentoId": movimiento.MovimientoDocumentoId,
                                        "SolicitudDocumentoId": movimiento.SolicitudDocumentoId,
                                        "FechaMovimiento": movimiento.FechaMovimiento,
                                        "UsuarioQuienPresta": movimiento.UsuarioQuienPresta,
                                        "UsuarioQuienRecibe": movimiento.UsuarioQuienRecibe,
                                        "AreaQuePresta": movimiento.AreaQuePresta,
                                        "AreaQueRecibe": movimiento.AreaQueRecibe,
                                        "AreaExterna": movimiento.AreaExterna,
                                        "IncidenteId": movimiento.IncidenteId,
                                        "Incidente": movimiento.Incidente,
                                        "VolumenId": movimiento.VolumenId,
                                        "Volumen": movimiento.Volumen,
                                        "TerceriaId": movimiento.TerceriaId,
                                        "Terceria": movimiento.Terceria,
                                        "TiposMovimientos": movimiento.TiposMovimientos,
                                        "FechaRecepcion": movimiento.FechaRecepcion
                                        }],
                                    });
              }
              else
              {
                chequeo.Movimientos.push({
                                    "MovimientoDocumentoId": movimiento.MovimientoDocumentoId,
                                    "SolicitudDocumentoId": movimiento.SolicitudDocumentoId,
                                    "FechaMovimiento": movimiento.FechaMovimiento,
                                    "UsuarioQuienPresta": movimiento.UsuarioQuienPresta,
                                    "UsuarioQuienRecibe": movimiento.UsuarioQuienRecibe,
                                    "AreaQuePresta": movimiento.AreaQuePresta,
                                    "AreaQueRecibe": movimiento.AreaQueRecibe,
                                    "AreaExterna": movimiento.AreaExterna,
                                    "IncidenteId": movimiento.IncidenteId,
                                    "Incidente": movimiento.Incidente,//!= null? datosEnvio.Incidente : null,
                                    "VolumenId": movimiento.VolumenId,
                                    "Volumen": movimiento.Volumen,//!=null ? datosEnvio.Volumen : null,
                                    "TerceriaId": movimiento.TerceriaId,
                                    "Terceria": movimiento.Terceria,//!=null ? datosEnvio.Terceria : null,
                                    "TiposMovimientos": movimiento.TiposMovimientos,
                                    "FechaRecepcion": movimiento.FechaRecepcion});
              }
              
            });
            
            return documentosSeleccionados;
        },
    },
    mounted(){
        this.AreaQueConsulta = this.$store.state.Login_Usuario;
        
    },
    computed:{
      ListaRecepcionSorted:function() {
        return this.ListaRecepcion.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    }
}
</script>
<style scoped>
    .thead-custom {
    background-color: #004746;
    color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/MovimientosUsuarios.vue